import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply } from "sources/books/fuelCards";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateFuelCardModal extends FormTemplate {
    sendRequest = (stateData) => apply(stateData);

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                renderCheckbox={this.renderCheckbox}
                data={this.state}
            />
        );
    };
}

const ConfiguredModal = (props) => <CreateFuelCardModal {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
